import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { AppRoot } from '@telegram-apps/telegram-ui'

import '@telegram-apps/telegram-ui/dist/styles.css'
import './styles.css'

import App from './App'
import { initTelegram, getWebApp } from './lib/telegram'

initTelegram()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

const wa = getWebApp() as any
const platform = wa?.platform === 'ios' || wa?.platform === 'macos' ? 'ios' : 'base'

// Принудительно тёмная тема — единый брендинг, независимо от темы клиента Telegram
const appearance = 'dark' as const

// Хедер Telegram и базовый фон страницы — в цвет нашего background, чтобы не было полоски сверху
try {
  wa?.setHeaderColor?.('#0F1115')
  wa?.setBackgroundColor?.('#0F1115')
} catch {}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AppRoot appearance={appearance} platform={platform}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </AppRoot>
    </QueryClientProvider>
  </StrictMode>,
)
